import React, { useEffect } from "react";
import dayjs from "dayjs";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

import {
  ALL,
  toFilterArray,
  removeFilterValue
} from "../../utils/placementFilters";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: 35,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    listStyle: "none",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}));

export default function ChipsArray(props) {
  const { filters, setFilters, placementSites } = props;
  const classes = useStyles();
  const [chipData, setChipData] = React.useState([]);

  useEffect(() => {
    const filterArray = [];

    const formatKey = (key) => {
      key = key.slice(0, 1).toUpperCase() + key.slice(1);
      if (
        key === "LeadTime" ||
        key === "ServingType" ||
        key === "LastModified"
      ) {
        key = key.split(/(?=[A-Z])/).join(" ");
        return key;
      } else {
        return key;
      }
    };

    const formatValue = (key, value) => {
      if (key === "site") {
        const site = placementSites[value];
        return site ? site.name : value;
      } else if (key === "lastModified") {
        const date = new Date(parseInt(value));
        return [
          ("0" + (date.getUTCMonth() + 1)).slice(-2),
          ("0" + date.getUTCDate()).slice(-2),
          ("0" + date.getUTCFullYear()).slice(-2)
        ].join("/");
      } else if (key === "start" || key === "end") {
        return dayjs(value).format("MM/DD/YY");
      } else if (key === "compatibility") {
        let word = value.slice(0, 1) + value.slice(1).toLowerCase();
        return word.replace("_", "").replace("_", " ");
      } else {
        return value;
      }
    };

    // One chip per selected value rather than per filter, so a single value
    // can be dropped without clearing the whole field. Previously a
    // multi-select filter rendered its comma-joined string as one chip and
    // formatted it as though it were a single value.
    for (const key of Object.keys(filters)) {
      for (const value of toFilterArray(filters[key])) {
        if (value === ALL) continue;
        filterArray.push({
          key,
          value,
          label: `${formatKey(key)}: ${formatValue(key, value)}`
        });
      }
    }

    setChipData(filterArray);
  }, [filters, placementSites]);

  const handleDelete = (chip) => () => {
    setFilters({
      ...filters,
      [chip.key]: removeFilterValue(filters[chip.key], chip.value)
    });
  };

  return (
    <div className={classes.root}>
      {chipData.map((data) => (
        <li key={`${data.key}-${data.value}`}>
          <Chip
            label={data.label}
            onDelete={handleDelete(data)}
            className={classes.chip}
          />
        </li>
      ))}
    </div>
  );
}
